import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledMenuModalHeader = styled.div`
  .show-more-button {
    background: none;
    color: ${baseVariables.color.base10};
  }

  .grid-view {
    display: grid;
    grid-template-columns: max-content auto;
    column-gap: ${toRem(4)};
  }
`;
